__turbopack_context__.v({
  "app_light_theme": "segmented-control-module-scss-module__zwb10q__app_light_theme",
  "button": "segmented-control-module-scss-module__zwb10q__button",
  "disabled": "segmented-control-module-scss-module__zwb10q__disabled",
  "md": "segmented-control-module-scss-module__zwb10q__md",
  "root": "segmented-control-module-scss-module__zwb10q__root",
  "sm": "segmented-control-module-scss-module__zwb10q__sm",
});
